import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { useMemo } from "react";
import { useAccountLimitsContext } from "../../../context/account-limit-context";
import { useLexicalContext } from "../lexical-context";
import { $isPollNode } from "../nodes/poll/helpers";
import { $findAllNodesOfType } from "./find-all-nodes-of-type";

export function usePolls(): boolean {
  const [editor] = useLexicalComposerContext();
  const { toChannel, channelName } = useLexicalContext();

  const { enable_polls } = useAccountLimitsContext();

  const hasNodes = useMemo(() => {
    let present = false;

    editor.update(
      () => {
        present = $findAllNodesOfType($getRoot(), $isPollNode).length > 0;
      },
      { discrete: true },
    );

    return present;
  }, [editor]);

  // Polls cannot be sent to teams channels, as we can't track the results.
  if (channelName === "teams" && toChannel) return false;

  return enable_polls || hasNodes;
}
